import { useAuth } from "@/auth/AuthContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { ValidationError } from "../types/errors";
import { UpdateMyProfileRequestDto } from "./dto";

// export interface UpdateMyProfileRequestDto {
//   name?: string;
//   nickname?: string;
//   phoneNumber?: string;
//   email?: string;
//   gender?: string;
//   maritalStatus?: MaritalStatus;
//   hasChildren?: HasChildren;
//   profession?: string;
//   nationality?: string;
//   birthDate?: Date; // ISO 8601 format
// }

const updateMyProfile = async (data: UpdateMyProfileRequestDto): Promise<void> => {
  const response = await apiFetch("api/users/me/profile", {
    method: "PATCH",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorBody = await response.json();

    // Check for validation errors in different possible structures
    let validationMessages: string[] | null = null;

    if (response.status === 400) {
      // Try different possible error structures
      if (Array.isArray(errorBody?.error?.message)) {
        validationMessages = errorBody.error.message;
      } else if (Array.isArray(errorBody?.message)) {
        validationMessages = errorBody.message;
      }
    }

    if (validationMessages) {
      throw new ValidationError(validationMessages);
    }

    // For other errors, throw regular error
    throw new Error(
      errorBody.message || `PATCH api/users/me/profile failed with status ${response.status}`
    );
  }
};

export function useUpdateMyProfile() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation<void, Error, UpdateMyProfileRequestDto>({
    mutationFn: updateMyProfile,
    onSuccess: () => {
      // Invalidate queries that depend on user profile data to refetch them
      // Invalidate myInfo to refetch user summary data
      queryClient.invalidateQueries({ queryKey: ["myInfo", user?.id] });
    },
  });
}
